import React from "react";
import { Container, Row, Col } from "shards-react";
import PageTitle from "../components/common/PageTitle";
import Editor from "../components/common/Editor";
import SidebarActions from "../components/add-new-post/SidebarActions";
import SidebarCategories from "../components/add-new-post/SidebarCategories";
import {firebases,files } from '../config';
import { MDBBtn, MDBBtnGroup, MDBIcon} from "mdbreact";
import {  MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import _ from 'underscore';
let context = null;

const header = [
  {
    label: 'Profile',
    field: 'profile',
    sort: 'asc',
    width: 40,
    type:"IMAGE",
    editType:"file"
  },
  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
    width: 150,
    editType:"text"
  },
  {
    label: 'Department',
    field: 'department',
    sort: 'asc',
    width: 270,
    editType:"LINKEDLIST",
    options:[]
  },
  {
    label: 'Phone',
    field: 'phone',
    sort: 'asc',
    width: 200,
    editType:"phone",
  },
  {
    label: 'Email',
    field: 'email',
    sort: 'asc',
    width: 100,
    editType:"email",
  },
  {
    label: 'Password',
    field: 'password',
    sort: 'asc',
    width: 150,
    editType:"password",
  },
  {
    label: 'Status',
    field: 'status',
    sort: 'asc',
    width: 100,
    editType:"SELECT",
    options:[{name:"Active",value:"ACTIVE"},{name:"Not Active",value:"NOTACTIVE"},]
  },
  {
    label: 'Actions',
    field: 'actions',
    sort: 'asc',
    width: 110,
    type:'ACTIONS'
  }
];

const baseName = "Blog";
const firebaseDb = firebases.database().ref().child('blogs');
const firebaseCategoryDb = firebases.database().ref().child('categories');
class AddNewPost extends React.Component  {


  constructor(props){
    super();
    this.state = {
      model:[],
      items:{},
      categories:[],
      selectedDate:new Date(),
      sourceList:[],
      isDeleted:false,
      isEdit:false,
      id:"",
      selectedFile: null,blogImageUrl:"",authorImageUrl:"",deleteModal:false,msg:""};
      context = this;
  }


  componentDidMount(){
   


    if(this.props.match.params.id!=undefined){

      this.setState({id:this.props.match.params.id});
      this.setState({isEdit:true});
      this.fetchItemFromDb(this.props.match.params.id);


    }
    else{
      this.getAllCategories();
    }

  }
  toggle = () => {



    this.setState({
      deleteModal: !this.state.deleteModal
    });

    if(context.state.isDeleted){
      context.setState({isDeleted:false});
      context.props.history.push('/Blog-posts');
    }

  }

fetchItemFromDb = (id)=>{

  firebaseDb.child(id).on('value', snap => {
    
  
    let row = {};
    console.log(snap);
    snap.forEach(shot => {




    
          row[shot.key] = shot.val();
        


      

     
    });


    context.setState({items: row}); 
    this.getAllCategories(row.categories);


  });


}



  addNewItemToDb = (status) => {
    let item = context.state.items;
    let categories = context.state.categories;
     let key = firebaseDb.push().key;
    item["key"] = key;
    item["status"] =status;
    item["categories"] = _.where(categories,{checked:true});
    firebaseDb.child(key).update(item);
    context.setState({msg:"Blog has been added"})
    context.setState({deleteModal:true});
    context.setState({isDeleted:true});
      
    
  };

  addNewCategoryToDb = () => {
    
if(context.state.category!=undefined && context.state.category!==""){


    let item = {name:context.state.category,checked:true};
    let key = firebaseCategoryDb.push().key;
    item["key"] = key;
    firebaseCategoryDb.child(key).update(item);
    context.setState({msg:"Category has been added"})
    context.setState({deleteModal:true});

        
}
    
  };

  deleteFromDb = (key) => {
    firebaseDb.child(context.state.id).remove();
    context.setState({msg:"Blog has been deleted",isDeleted:true});
    context.setState({deleteModal:true});
 
  };

  

  onFileUpload=(event,imageName)=>{
    
    
    context.setState({
      selectedFile: event.target.files[0],
      [imageName+"Url"]: URL.createObjectURL(event.target.files[0])
     
    });

    let storage =  files;

      storage.child(event.target.files[0].name).put(event.target.files[0]).then(function(snapshot) {
        snapshot.ref.getDownloadURL().then(function(downloadURL) {
        context.setState({msg:"Image Has been uploaded!"})
        context.setState({deleteModal:true});
        context.setState({ items: { ...context.state.items,[imageName]:downloadURL} })
        });
      });

}
  

handleUpdateBlog = () => {
    
    let item = context.state.items;
    let id = context.state.id; 
    let categories = context.state.categories;
    item["categories"] = _.where(categories,{checked:true});


    firebaseDb.child(id).update(item);
    context.setState({msg:"Item has been updated"})
    context.setState({deleteModal:true});
    context.setState({isDeleted:true});
    
  };


  handleChange = (e) =>{

    let name = e.target.name;
    let value = e.target.value;

    this.setState({ items: { ...this.state.items, [name]:value} });


   } 

   handleEditorChange=(value,name)=>{
    this.setState({ items: { ...this.state.items, [name]:value} });
   }

   handleChangeCategory = (e) =>{

    let name = e.target.name;
    let value = e.target.value;

    this.setState({[name]:value});


   } 

   handleCheckedCategory = (key) =>{

   
    
    let list = context.state.categories;

    _.each(list,function(item){

        if(item.key===key){

          item["checked"] = !item.checked;
        }


    });

    context.setState({ categories:list });



   } 


 handleDateChange(value,name) {

    context.setState({ items: { ...context.state.items, [name]: new Date(value)} });
  }

  getAllCategories=(selectedCategories)=>{

    firebaseCategoryDb.on('value', snap => {
        
        let dbList = [];
        let sourceList = [];
        let category={};
        console.log(snap);
        snap.forEach(shot => {

          category = _.findWhere(selectedCategories,{name:shot.val().name});

          dbList.push({name:shot.val().name,checked:(category!=undefined ? true : false), key: shot.key });
          sourceList.push({name:shot.val().name,checked:(category!=undefined ? true : false), key: shot.key });
        });
    
    
        context.setState({categories: dbList.reverse()}); 
        context.setState({sourceList: sourceList}); 
    
    
      });
      



  }


  render(){
const {categories,msg,isDeleted} = this.state;
    return (<Container fluid className="main-content-container px-4 pb-4">
    {/* Page Header */}
    <Row noGutters className="page-header py-4">
      <PageTitle sm="4" title="Add New Post" subtitle="Blog Posts" className="text-sm-left" />
    </Row>

    <Row >
      {/* Editor */}
      <Col style={{'height': '80vh',overflow:'auto'}} lg="9" md="12">
        <Editor
        handleDateChange={this.handleDateChange}
        handleEditorChange={this.handleEditorChange}
        fileUrl={this.state.blogImageUrl} onFileUpload={this.onFileUpload} item={this.state.items} handleChange={this.handleChange} type="BLOG"/>
       
        <Editor  handleEditorChange={this.handleEditorChange} fileUrl={this.state.authorImageUrl} item={this.state.items} 
        onFileUpload={this.onFileUpload}   handleChange={this.handleChange} type="AUTHOR"/>
      </Col>

      {/* Sidebar Widgets */}
      <Col lg="3" md="12">
        <SidebarActions 
        deleteFromDb={this.deleteFromDb}
        deleteModal={this.deleteModal} toggle={this.toggle} msg={this.state.msg} 
        isEdit={this.state.isEdit} selectedDate={this.state.selectedDate} handleAddBlog={this.addNewItemToDb}
        handleUpdateBlog={this.handleUpdateBlog}  handleDateChange={this.handleDateChange} />
        <SidebarCategories
           handleChange={this.handleChangeCategory} handleCheckedCategory={this.handleCheckedCategory} list={categories} onCategoryAdd={this.addNewCategoryToDb} />
      </Col>
    </Row>

   <Row>
  <Col>
  <MDBModal isOpen={this.state.deleteModal} toggle={this.toggle} size="sm">
        <MDBModalHeader toggle={this.toggle}>Information</MDBModalHeader>
        <MDBModalBody>
        {msg}
        </MDBModalBody>
        <MDBModalFooter>
          <MDBBtn color="secondary" size="sm" onClick={this.toggle}>Ok</MDBBtn>
         
        </MDBModalFooter>
      </MDBModal> 

  </Col>
</Row>
  
  </Container>);
  }
  
}

export default AddNewPost;
